<template>
    <div>
        <b-modal id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer
            ref="modal-timeout-excercise">
            <div class="modal-delete-lesson__body container wrap-form-create-update-chapter">
                <div class="tittle">
                    <h4>Đã hết giờ làm bài. Bài làm đã được nộp</h4>
                </div>

                <div class="list__actions">
                    <button type="button" class="btn-back" @click="handleHideModal">Đồng ý</button>
                </div>

            </div>
        </b-modal>

    </div>

</template>

<script>
export default {
    name: "ModalTimeOutExcercise",

    mounted() {
        this.handleShowModal()
    },
    methods: {
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-timeout-excercise'].show()
        },
    }
}
</script>

<style scoped lang="scss">
.tittle {
    margin: 15px 0;
}
.modal-delete-lesson__body{
    background-color: white;
}
.list__actions .btn-back {
    border: none;
    background: none;
    margin: 10px 0;
    padding: 4px 35px;
    border-radius: 20px;
    background-color: #ff4953;
    color: white;
}

.list__actions {
    display: flex;
    justify-content: flex-end;
}
</style>